import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, input, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { TextinputComponent } from '../components/textinput/textinput.component';
import { CallCheckListService } from '../../services/call-checklist.service';
import { RadioButtonComponent } from '../components/radiobutton/radiobutton.component';
import { TextareaComponent } from '../components/textarea/textarea.component';
import { FormsModule, NgForm } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { OrderTypeData } from '../interfaces/OrderEntryRecords';
import { environment } from '../../environments/environment';
import { Emergencies } from '../order-entry/order-entry-model/order-entry.model';
import { ActivatedRoute } from '@angular/router';
import { Appconstants } from '../utils/appconstants';
import { ControlUtils } from '../utils/control-utils';
import { ApiService } from '../../services/apiservice';
import { OrderEntrySharedService } from '../../services/order-entry-shared.service';
import leakageTypeData from '../call-checklist/leakage-by-emergency.json'
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { MyMonitoringService } from '../../services/logging.service';

@Component({
  selector: 'app-call-checklist',
  imports: [CommonModule, FormsModule,
    DropdownComponent, TextinputComponent,
    RadioButtonComponent, TextareaComponent
  ],
  templateUrl: './call-checklist.component.html',
  styleUrl: './call-checklist.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
})

export class CallChecklistComponent {
  orderTypePayLoad!: OrderTypeData[];
  isSuccess: boolean = false;;
  isLoading: boolean = true;
  isFailure: boolean = false;;
  messageService: any;
  leakageTypeData = leakageTypeData;

  orderTypeConfig: any = undefined;

  constructor(private callCheckListService: CallCheckListService,
    private cdr: ChangeDetectorRef, private monotoringService: MyMonitoringService,
    private orderEntrySharedService: OrderEntrySharedService, private apiService: ApiService,
    private route: ActivatedRoute) {
  }

  callerTypes = ['Customer', 'Passer By', 'Other'];
  soundGas = ['None', 'Light', 'Heavy'];
  leakageType = ['Inside', 'Outside'];
  isYesNo = [Appconstants.Yes, Appconstants.No];
  callerTypeValue: string = '';
  soundGasValue!: string;
  odorfirstnoticed?: string;
  leakageValue!: string;
  roomValue: string = '';
  applianceValue: string = '';
  additionaloutsidelocation: string = '';
  workInProgressValue: string = '';
  isLeakApplianceValue: string = '';
  isLeakHousePipingValue: string = '';
  additionalEmergencyValue?: string;
  typeValue: string = '';
  buildingDropdownOptions: any;
  buildingSelectedValue: string = '';
  leakedDropdownOptions: any;
  leakedSelectedValue: string = '';
  isCustomClass: boolean = false;
  customerChecked: boolean = false;
  passerByChecked: boolean = false;
  otherChecked: boolean = false;
  callerType: boolean = false;
  advisoriesData: any[] | undefined;
  Passer: any[] | undefined;
  otherData: any[] | undefined;
  isLeakageInside: boolean | undefined;
  isLeakageOutside: boolean | undefined;
  @Input() emergencies!: Emergencies | null;

  @ViewChild('callCheckList') callCheckListForm!: NgForm;
  @Output() formStatusChange = new EventEmitter<boolean>();
  @Output() formValuesChange = new EventEmitter<any>();
  @Input() isEnableLeaked: boolean = false;
  @Input() isEmerComments: boolean = false;
  @Input() isFirstOrderNotice: boolean = false;
  @Output() callerTypeChanged = new EventEmitter<string>();
  @Input() isLeakageEnabled: boolean = false;
  @Input() OrderTypeValue: string = '';

  ngOnInit(): void {
    this.getBuildingLeakage();
    var ccrId = this.route.snapshot.paramMap.get('ccrId');
  }

  ngOnChanges(changes: SimpleChanges) {
    this.orderTypeConfig = this.leakageTypeData.config.find(d => d.orderTpe.toLowerCase()
      === this.OrderTypeValue.toLowerCase());
    if (changes['emergencies'] && changes['emergencies'].currentValue) {
      if (this.emergencies) {
        this.additionalEmergencyValue = this.emergencies.AdditionalEmergency;
        this.additionaloutsidelocation = this.emergencies.AdditionalOutsideLocation;
        this.applianceValue = this.emergencies.Appliance;
        this.buildingSelectedValue = this.emergencies.BuildingSelected;
        this.isLeakApplianceValue = this.emergencies.IsLeakAppliance;
        this.isLeakHousePipingValue = this.emergencies.IsLeakHousePiping;
        //this.leakageValue = this.emergencies.LeakageType;     
        this.leakageValue = this.emergencies.LeakageType?.trim() ?? '';
        this.leakedSelectedValue = this.emergencies.LeakedSelected;
        this.odorfirstnoticed = this.emergencies.OdorFirstNoticed;
        this.roomValue = this.emergencies.Room;
        this.soundGasValue = this.emergencies.SoundGas;
        this.typeValue = this.emergencies.Type;
        this.workInProgressValue = this.emergencies.WorkInProgress;
        //this.cdr.detectChanges();
      }
    }
  }

  customerClicked(): void {
    this.callerType = true;
    this.customerChecked = true;
    this.passerByChecked = false;
    this.otherChecked = false;
    this.callerTypeChanged.emit('Customer');
    this.emitFormValidity();
  }

  passerByClicked(): void {
    this.callerType = true;
    this.customerChecked = false;
    this.passerByChecked = true;
    this.otherChecked = false;
    this.callerTypeChanged.emit('Passer By');
    this.emitFormValidity();
  }

  otherClicked(): void {
    this.callerType = true;
    this.customerChecked = false;
    this.passerByChecked = false;
    this.otherChecked = true;
    this.callerTypeChanged.emit('Other');
    this.emitFormValidity();
  }

  oncallerTypesChange(selectedValue: string) {
    this.callerTypeValue = selectedValue;
    if (selectedValue == 'Customer') {
      this.customerClicked();
    } else if (selectedValue == 'Passer By') {
      this.passerByClicked();
    } else {
      this.otherClicked();
    }
    // this.emitFormValidity();
  }

  onSoundGasChange(selectedValue: string) {
    this.soundGasValue = selectedValue;
    this.emitFormValidity();
  }

  onodorfirstnoticedChange(selectedValue: string) {
    this.odorfirstnoticed = selectedValue;
    this.emitFormValidity();
  }

  onleakageTypeChange(selectedValue: string) {
    this.leakageValue = selectedValue;
    this.isLeakageInside = selectedValue === 'Inside';
    this.isLeakageOutside = selectedValue === 'Outside'
    this.emitFormValidity();
  }

  checkLeakageTypeInside(): any {
    return this.isLeakageInside !== undefined && this.isLeakageInside;
  }

  checkLeakageTypeOutside(): any {
    return this.isLeakageOutside !== undefined && this.isLeakageOutside;
  }

  onBuildingChange(selectedValue: string) {
    this.buildingSelectedValue = selectedValue;
    this.emitFormValidity();
  }

  onRoomChange(selectedValue: string) {
    this.roomValue = selectedValue;
    this.emitFormValidity();
  }

  onApplianceChange(selectedValue: string) {
    this.applianceValue = selectedValue;
    this.emitFormValidity();
  }

  onLeakApplianceChange(selectedValue: string) {
    this.isLeakApplianceValue = selectedValue;
    this.emitFormValidity();
  }


  onLeakHousePipingChange(selectedValue: string) {
    this.isLeakHousePipingValue = selectedValue;
    this.emitFormValidity();
  }

  onLeakLocatedChange(selectedValue: string) {
    const value = selectedValue;
    this.callCheckListForm.value.leakedSelectedValue = value;
    this.leakedSelectedValue = value;
    this.emitFormValidity();
  }

  onworkInProgressChange(selectedValue: string) {
    this.workInProgressValue = selectedValue;
    this.emitFormValidity();
  }

  onadditionaloutsidelocationChange(Val: string) {
    if (typeof Val === 'string') {
      this.additionaloutsidelocation = Val;
      this.emitFormValidity();
    }
  }

  onTypeChange(Val: string) {
    this.typeValue = Val;
    this.emitFormValidity();
  }

  onadditionalEmergencyChange(Val: any) {
    if (typeof Val === 'string') {
      this.additionalEmergencyValue = Val;
      this.emitFormValidity();
    }
  }

  getBuildingLeakage(): void {
    this.orderEntrySharedService.orderTypeData.subscribe({
      next: (data: { Payload: OrderTypeData[]; }) => {
        this.orderTypePayLoad = data.Payload
        this.buildingDropdownOptions = ControlUtils.buildDropDownOptions(this.orderTypePayLoad.filter(item => item.Code === 'BuildingType').map(item => item.Value)
          .sort((a, b) => a.localeCompare(b)));

        this.leakedDropdownOptions = ControlUtils.buildDropDownOptions(this.orderTypePayLoad.filter(item => item.Code === 'LeakLocation').map(item => item.Value)
          .sort((a, b) => a.localeCompare(b)));
        this.isSuccess = true;
      },
      error: (error: string) => {
        this.isLoading = false;
        this.isFailure = true;
        const errMsg = environment.appMessages.ServerError;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallChecklistComponent.getBuildingLeakage', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  ngAfterViewInit() {
    this.emitFormValidity();
  }

  mapCheckListData() {
    this.callCheckListForm.value.roomValue = this.roomValue;
    this.callCheckListForm.value.applianceValue = this.applianceValue;
    this.callCheckListForm.value.applianceValue = this.applianceValue;
    this.callCheckListForm.value.buildingSelectedValue = this.buildingSelectedValue;
    this.callCheckListForm.value.leakedSelectedValue = this.leakedSelectedValue;
  }

  emitFormValidity() {
    setTimeout(() => {
      if (this.callCheckListForm) {
        this.mapCheckListData();
        this.formStatusChange.emit(this.callCheckListForm?.valid ?? false);
        this.formValuesChange.emit(this.callCheckListForm.value);
      }
    }, 0);
    this.cdr.detectChanges();
  }
  checkFormValidity() {
    const isValid = this.callCheckListForm.valid ?? false;
    this.formStatusChange.emit(isValid);
  }
}
